const BASE_FILTER_KEYS = [
  'provider',
  'expense_class',
  'category',
  'customer',
  'tags',
  'has_xml',
  'currency',
  'area',
];

const resolveFilterKeys = ({ includeCollaborator = false } = {}) => {
  return includeCollaborator
    ? ['provider', 'collaborator', ...BASE_FILTER_KEYS.slice(1)]
    : BASE_FILTER_KEYS;
};

export const createDefaultExpenseFeeToolbarFilters = ({ includeCollaborator = false } = {}) => {
  const defaults = {
    search: '',
    date_start: '',
    date_end: '',
  };

  resolveFilterKeys({ includeCollaborator }).forEach((key) => {
    defaults[key] = [];
  });

  return defaults;
};

export const normalizeExpenseFeeToolbarFilters = (filters, { includeCollaborator = false } = {}) => {
  const normalized = filters && typeof filters === 'object' ? filters : {};

  const next = {
    ...createDefaultExpenseFeeToolbarFilters({ includeCollaborator }),
    ...normalized,
  };

  resolveFilterKeys({ includeCollaborator }).forEach((key) => {
    next[key] = Array.isArray(next[key]) ? next[key] : [];
  });

  next.search = String(next.search || '').trim();
  next.date_start = String(next.date_start || '').trim();
  next.date_end = String(next.date_end || '').trim();

  return next;
};

export const buildExpenseFeeListParams = ({
  toolbarFilters,
  toolbarSearch,
  statusTab = 'all',
  includeCollaborator = false,
}) => {
  const filters = normalizeExpenseFeeToolbarFilters(toolbarFilters, { includeCollaborator });
  const normalizedStatusTab = String(statusTab || '').trim();
  const isAllStatus = normalizedStatusTab === ''
    || normalizedStatusTab.toLowerCase() === 'all'
    || normalizedStatusTab.toLowerCase() === 'todos';
  const tabIsNumericId = /^\d+$/.test(normalizedStatusTab);

  const params = {
    search: String(filters.search || toolbarSearch || '').trim(),
    date_start: filters.date_start,
    date_end: filters.date_end,
    provider: filters.provider,
    expense_class: filters.expense_class,
    category: filters.category,
    customer: filters.customer,
    tags: filters.tags,
    has_xml: filters.has_xml,
    currency: filters.currency,
    area: filters.area,
    tab: isAllStatus || tabIsNumericId ? '' : normalizedStatusTab,
    payment_type: !isAllStatus && tabIsNumericId ? [Number(normalizedStatusTab)] : [],
  };

  if (includeCollaborator) {
    params.collaborator = filters.collaborator;
  }

  return params;
};
